import * as React from 'react';
import Spinner from 'react-spinkit';
import cx from 'classnames';
import Form from 'react-bootstrap/Form';
import PrimaryButton from '../components/PrimaryButton/PrimaryButton';
import styles from './ResellerSelector.module.scss';

interface IProps {
  isPeekapakAdmin: boolean;
  resellersList: string[];
  onSelectReseller: (arg0: React.SyntheticEvent<HTMLInputElement>) => void;
  onReload: (arg0: React.SyntheticEvent<HTMLButtonElement>) => void;
  initialValue: string;
  disableChangeReseller: boolean;
}

const SellerSelector = ({
  isPeekapakAdmin,
  resellersList,
  onSelectReseller,
  onReload,
  initialValue,
  disableChangeReseller,
}: IProps): JSX.Element => {
  if (resellersList.length === 0) {
    return (
      <div className={styles.sellerSelectorContainer}>
        <div className={cx(styles.sellerSelector, styles.inlineSelector, styles.selectorErrorMessage)}>
          There are no sellers listed in the database
        </div>
        <div>
          <PrimaryButton small onClick={onReload}>
            Reload <i className='fa fa-repeat'></i>
          </PrimaryButton>
        </div>
      </div>
    );
  }

  if (!initialValue) {
    return (
      <div className={styles.selectorErrorMessage}>
        <Spinner name='line-scale' />
      </div>
    );
  }

  return (
    <div className={styles.sellerSelectorContainer}>
      <div className={cx(styles.sellerSelector, styles.inlineSelector)}>
        <Form inline>
          <Form.Group controlId='sellerSelector'>
            <Form.Label>Reseller</Form.Label>
            <Form.Control
              as='select'
              onChange={onSelectReseller}
              defaultValue={initialValue}
              disabled={disableChangeReseller}
            >
              {resellersList.map((e) => (
                <option value={e.id} key={e.id}>
                  {e.name}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </Form>
      </div>
      <PrimaryButton small onClick={onReload}>
        Reload <i className='fa fa-repeat'></i>
      </PrimaryButton>
    </div>
  );
};

export default SellerSelector;
